// extracted by mini-css-extract-plugin
export var infoRow = "_tp-2";
export var labelContainer = "_tp-0";
export var rightInfo = "_tp-1";